@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.styledButton {
  @include border-radius-r2;

  @include respond-to('max-sm') {
    border: 0;

    &:focus {
      border: 0;
    }
  }
}
